import React from 'react';
import { FaRegImage } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";

interface LineItemConfig {
  colSpan: number;
  label: string;
  text?: string;
  node?: React.ReactNode;
  value: boolean;
  onClick: () => void;
}

interface InteractableLineItemProps {
  config: LineItemConfig[];
}

const InteractableLineItem: React.FC<InteractableLineItemProps> = ({ config }) => {
  const colStyle = "cursor-pointer transition-all duration-200 p-1 rounded";
  const includes = (value: boolean) => {
    return value ? 'text-gray-900 hover:bg-blue-50' : 'text-gray-300 bg-gray-50'
  };

  return (
    <div>
      {/* Header Row */}
      <div className="grid grid-cols-12 gap-2 text-xs font-semibold text-gray-500 mb-1.5 px-2">
        {config.map((config, i) => (
          <div key={i} className={`col-span-${config.colSpan} flex items-center`}>
            <div>{config.label}</div>
            {!config.value ? <IoClose className="text-red-500 ml-1" size={18} /> : <FaCheck className="text-green-500 ml-1" size={18} />}
          </div>
        ))}
      </div>

      {/* Interactive Line Item */}
      <div className="border border-gray-200 rounded-lg overflow-hidden bg-white mb-2">
        <div className="grid grid-cols-12 gap-2 p-2 items-center">
          {config.map((config, i) => (
            <div key={i} className={`col-span-${config.colSpan} ${colStyle} ${includes(config.value)}`} onClick={config.onClick}>
              {config.text && config.text}
              {config.node && config.node}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InteractableLineItem; 